// extracted by mini-css-extract-plugin
module.exports = {"socialLinkVertical":"SocialIcons_socialLinkVertical__1Mihf","socialIconsContainer":"SocialIcons_socialIconsContainer__2hQpX","socialLink":"SocialIcons_socialLink__k2KWr"};